import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoginRoutingModule } from "./login-routing.module";
import { LoginScreenComponent } from "./login-screen/login-screen.component";
import { RegistrationScreenComponent } from "./registration-screen/registration-screen.component";
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule
  } from "@angular/material";
//   import {MatFormFieldModule} from '@angular/material/form-field';
import {MatButtonModule} from '@angular/material/button';
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
import { VerifyForgotPasswordComponent } from './verify-forgot-password/verify-forgot-password.component';
import { SetPasswordComponent } from './set-password/set-password.component';
import { RECAPTCHA_SETTINGS, RecaptchaModule, RecaptchaSettings, RecaptchaFormsModule } from 'ng-recaptcha';
import { RECAPTCHA_SITE_KEY } from "../app.constants";

import { CommonComponentsModule } from '../features/common-components/common-components.module';
import { EventFormSubmissionComponent } from '../features/home/events/event-form-submission/event-form-submission.component'
import { FeedbackSubmissionComponent } from '../features/home/events/event-feedback/feedback-submission/feedback-submission.component';
import { RsvpUnavailabityConfirmComponent } from '../features/home/events/rsvp-unavailabity-confirm/rsvp-unavailabity-confirm.component';
import { NotificationThanksComponent } from './notification-thanks/notification-thanks.component';
import {MatTabsModule} from '@angular/material/tabs';
@NgModule({
  declarations: [
    LoginScreenComponent,
    RegistrationScreenComponent,
    ResetPasswordComponent,
    VerifyForgotPasswordComponent,
    SetPasswordComponent,
    EventFormSubmissionComponent,
    FeedbackSubmissionComponent,
    RsvpUnavailabityConfirmComponent,
    NotificationThanksComponent
  ],
  imports: [
    MatCardModule,
    LoginRoutingModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    MatButtonModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    CommonComponentsModule,
    MatTabsModule
  ],
  providers: [{
    provide: RECAPTCHA_SETTINGS,
    useValue: {
      siteKey: RECAPTCHA_SITE_KEY,
    } as RecaptchaSettings,
  }],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [],
  entryComponents:[NotificationThanksComponent]
})
export class LoginModule {}
